const BACKGROUND_GRAPHQL = {
  aws_appsync_graphqlEndpoint:
    "https://4abruykm2nfepmddgv6inewjm4.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-ypvjyqq74vhhresmzcmkdiulgi", // might expire on Nov 17
};

export default BACKGROUND_GRAPHQL;
